import React from 'react';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';
import Col from 'components/ui/Col';
import Spacer from 'components/ui/Spacer';
import Row from 'components/ui/Row';
import BorderlessTable from 'components/ui/BorderlessTable';

const StyledTitle = styled.span`
  font-size: 18px;
  font-family: 'Circular-Bold';
`;

const StyledColMb8 = styled(Col)`
  margin-bottom: 8px;
`;

const StyledColMb8RightAlign = styled(Col)`
  margin-bottom: 8px;
  text-align: right;
`;

const GrayWeightTtile = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: #4f4f4f;
`;

const TABLE_HEIGHT = '400px';

const RsvpDetails = ({ values }) => {
  const tableData = values.rsvp_details.confirmed_guests || [];

  const eventHasGuests = tableData.length > 0;

  const headers = [
    {
      key: 'name',
      label: getTranslatedString('landlordPortal.events.RsvpTableHeaderName'),
      width: '40%',
      family: 'Circular-Bold',
    },
    {
      key: 'property',
      label: getTranslatedString('landlordPortal.events.RsvpTableHeaderProperty'),
    },
    {
      key: 'unit_number',
      label: getTranslatedString('landlordPortal.events.RsvpTableHeaderUnit'),
    },
    {
      key: 'rsvp_date',
      label: getTranslatedString('landlordPortal.events.RsvpTableHeaderDate'),
      format: 'date',
    },
  ];
  return (
    <Spacer mb={1}>
      <Row gutter={16}>
        <StyledColMb8 span={24}>
          <StyledTitle>{getTranslatedString('landlordPortal.events.RsvpDetailsLabel')}</StyledTitle>
        </StyledColMb8>
        <Col span={12}>
          <StyledColMb8>
            <GrayWeightTtile>
              {getTranslatedString('landlordPortal.events.RsvpGuestsConfirmedLabel')}
            </GrayWeightTtile>
          </StyledColMb8>
          <StyledColMb8>
            <StyledTitle>{values.rsvp_details.number_of_confirmed}</StyledTitle>
          </StyledColMb8>
        </Col>
        <Col span={12}>
          <StyledColMb8RightAlign>
            <GrayWeightTtile>
              {getTranslatedString('landlordPortal.events.RsvpGuestsInvitedLabel')}
            </GrayWeightTtile>
          </StyledColMb8RightAlign>
          <StyledColMb8RightAlign>
            <StyledTitle>{values.rsvp_details.total_invited}</StyledTitle>
          </StyledColMb8RightAlign>
        </Col>
        {eventHasGuests && (
          <Row>
            <Col span={24}>
              <StyledTitle>
                {getTranslatedString('landlordPortal.events.RsvpConfirmedGuestsLabel')}
              </StyledTitle>
            </Col>

            <Col span={24}>
              <BorderlessTable headers={headers} data={tableData} tableHeight={TABLE_HEIGHT} />
            </Col>
          </Row>
        )}
      </Row>
    </Spacer>
  );
};

export default RsvpDetails;
